import { useState } from "react";

interface LoginModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function LoginModal({ isOpen, onClose }: LoginModalProps) {
  const [tab, setTab] = useState<"login" | "register">("login");
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [agreed, setAgreed] = useState(false);

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center">
      <div className="absolute inset-0 bg-black/50" onClick={onClose}></div>
      <div className="relative bg-white rounded-2xl w-full max-w-sm mx-4 overflow-hidden">
        {/* Header */}
        <div className="bg-gradient-to-r from-red-500 to-red-600 p-6 text-white">
          <div className="flex items-center justify-between mb-4">
            <div className="flex items-center gap-2">
              <img
                src="https://public.readdy.ai/ai/img_res/f704ac6a-a45e-41ab-b34d-a4b4313691a9.png"
                alt="Logo"
                className="w-8 h-8 object-contain"
              />
              <span className="font-bold text-lg">皇冠鸿运商城</span>
            </div>
            <button onClick={onClose} className="w-7 h-7 flex items-center justify-center hover:bg-white/20 rounded-full cursor-pointer transition-colors">
              <i className="ri-close-line text-lg"></i>
            </button>
          </div>
          <p className="text-white/80 text-sm">登录后享受更多专属优惠</p>
        </div>

        {/* Tabs */}
        <div className="flex border-b border-gray-100">
          <button
            onClick={() => setTab("login")}
            className={`flex-1 py-3 text-sm font-medium transition-colors cursor-pointer ${tab === "login" ? "text-red-500 border-b-2 border-red-500" : "text-gray-400"}`}
          >
            登录
          </button>
          <button
            onClick={() => setTab("register")}
            className={`flex-1 py-3 text-sm font-medium transition-colors cursor-pointer ${tab === "register" ? "text-red-500 border-b-2 border-red-500" : "text-gray-400"}`}
          >
            注册
          </button>
        </div>

        {/* Form */}
        <div className="p-6">
          <div className="space-y-4">
            <div>
              <label className="text-xs text-gray-500 mb-1 block">手机号码</label>
              <div className="flex items-center border border-gray-200 rounded-lg overflow-hidden">
                <span className="px-3 py-2.5 text-sm text-gray-500 bg-gray-50 border-r border-gray-200">+86</span>
                <input
                  type="tel"
                  value={phone}
                  onChange={(e) => setPhone(e.target.value)}
                  placeholder="请输入手机号"
                  className="flex-1 px-3 py-2.5 text-sm outline-none"
                />
              </div>
            </div>
            <div>
              <label className="text-xs text-gray-500 mb-1 block">密码</label>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder={tab === "login" ? "请输入密码" : "设置6-20位密码"}
                className="w-full border border-gray-200 rounded-lg px-3 py-2.5 text-sm outline-none focus:border-red-400"
              />
            </div>
            {tab === "login" && (
              <div className="flex items-center justify-between">
                <label className="flex items-center gap-2 cursor-pointer">
                  <input type="checkbox" className="accent-red-500" />
                  <span className="text-xs text-gray-500">记住我</span>
                </label>
                <button className="text-xs text-red-500 hover:underline cursor-pointer">忘记密码？</button>
              </div>
            )}
            <label className="flex items-start gap-2 cursor-pointer">
              <input
                type="checkbox"
                checked={agreed}
                onChange={(e) => setAgreed(e.target.checked)}
                className="accent-red-500 mt-0.5"
              />
              <span className="text-xs text-gray-400 leading-relaxed">
                我已阅读并同意
                <button className="text-red-500 hover:underline cursor-pointer">《用户协议》</button>
                和
                <button className="text-red-500 hover:underline cursor-pointer">《隐私政策》</button>
              </span>
            </label>
          </div>

          <button
            disabled={!agreed}
            className="mt-5 w-full bg-red-500 hover:bg-red-600 disabled:bg-gray-200 disabled:cursor-not-allowed text-white py-3 rounded-xl font-bold transition-colors cursor-pointer whitespace-nowrap"
          >
            {tab === "login" ? "立即登录" : "立即注册"}
          </button>

          <div className="mt-4">
            <div className="flex items-center gap-3 mb-4">
              <div className="flex-1 h-px bg-gray-100"></div>
              <span className="text-xs text-gray-400">其他登录方式</span>
              <div className="flex-1 h-px bg-gray-100"></div>
            </div>
            <div className="flex items-center justify-center gap-4">
              <button className="w-10 h-10 flex items-center justify-center border border-gray-200 rounded-full hover:bg-gray-50 cursor-pointer transition-colors">
                <i className="ri-wechat-line text-green-500 text-xl"></i>
              </button>
              <button className="w-10 h-10 flex items-center justify-center border border-gray-200 rounded-full hover:bg-gray-50 cursor-pointer transition-colors">
                <i className="ri-qq-line text-blue-500 text-xl"></i>
              </button>
              <button className="w-10 h-10 flex items-center justify-center border border-gray-200 rounded-full hover:bg-gray-50 cursor-pointer transition-colors">
                <i className="ri-weibo-line text-red-400 text-xl"></i>
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
